import { ILayer, IMapContainer } from "../../map/types";
import { useForceUpdate } from "../hooks";
import { PopupContentProps } from "../Popup";
import { BasemapListItem } from "./Basemap";
import { Layer } from "./Layer";

interface Props extends PopupContentProps {
    readonly map: IMapContainer;
}

export function MapViewOptionsPopup({ map, close }: Props) {
    const refresh = useForceUpdate();

    const options = map.getUserOptions();

    const { additionalBasemaps: customBasemaps, basemaps } = options;

    const basemapGroups = (customBasemaps ?? []).concat(basemaps).filter((i) => i && map.isBasemapAvailable(i));

    const layers = options.baseLayers ?? [];

    const layersWithCustomComponent = layers.filter((x) => x.OptionsComponent);

    const layersWithoutCustomComponent = layers.filter((x) => !x.OptionsComponent);

    return (
        <div className="omnia-map-layers-popup">
            {layersWithCustomComponent.map((layer) => {
                const OptionsComponent = layer.OptionsComponent().component as React.ComponentType<{
                    layer: ILayer;
                    update: (func: () => void) => void;
                }>;
                return (
                    <OptionsComponent
                        key={layer.description}
                        layer={layer}
                        update={(action) => {
                            action?.();
                            // Force Angular to notice any changes made by React.
                            map.$apply();
                            // Force React to re-render to incorporate any changes made by Angular in response.
                            refresh();
                        }}
                    />
                );
            })}

            <ul className="list-unstyled">
                {layersWithoutCustomComponent.map((layer, index) => (
                    <li key={index} className="item--layer">
                        <Layer map={map} layer={layer} onUpdate={refresh} />
                    </li>
                ))}

                {basemapGroups.map((bmg) => (
                    <li key={bmg.basemap.name} className="item--basemap">
                        <BasemapListItem {...{ map, bmg }} />
                    </li>
                ))}
            </ul>

            <div className="text-right">
                <button className="btn btm-xs btn-warning" type="button" onClick={close}>
                    Close
                </button>
            </div>
        </div>
    );
}
